import React from 'react';
import './Stoggle.css';

interface StoggleProps {
  isOn: boolean;
  onToggle?: (isOn: boolean) => void;
  className?: string;
  disabled?: boolean;
  'aria-label'?: string;
}

const Stoggle: React.FC<StoggleProps> = ({ 
  isOn = false, 
  onToggle, 
  className = '',
  disabled = false,
  'aria-label': ariaLabel
}) => {
  const handleToggle = () => {
    if (!disabled && onToggle) {
      onToggle(!isOn);
    }
  };

  return (
    <button
      className={`stoggle ${isOn ? 'on' : 'off'} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleToggle}
      disabled={disabled}
      aria-label={ariaLabel || `Toggle ${isOn ? 'off' : 'on'}`}
      type="button"
    >
      <div className="stoggle-knob"></div>
    </button>
  );
};

export default Stoggle;
